import script from "./LilaChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./LilaChatMessage.vue?vue&type=style&index=0&id=d898ce1a&lang=css"

const __exports__ = script;

export default __exports__